import { z } from 'zod'

// shared date validator for the list-endpoint date-range query params (startDate/endDate). the
// frontend sends a full ISO-8601 datetime with offset (e.g. 2024-03-01T00:00:00Z), so all three
// list queries (expenses/incomes/transfers) validate identically here rather than drifting —
// previously incomes was strict while expenses/transfers accepted any string, letting junk reach
// `new Date()` as an Invalid Date. (#305)
export const queryDateTime = z.string().datetime({ offset: true })
